import { TFunction } from 'i18next'

import GalleryIcon from '@wwt/shared/assets/icons/outline/gallery.svg'
import LocationIcon from '@wwt/shared/assets/icons/outline/location.svg'
import PriceTagIcon from '@wwt/shared/assets/icons/outline/price-tag.svg'
import StarsIcon from '@wwt/shared/assets/icons/outline/stars.svg'

export const getQuickDislikeActions = (t: TFunction<'tooltips', undefined>) => [
	{
		quickActionIcon: PriceTagIcon,
		tooltipIcon: PriceTagIcon,
		tooltipTitle: t('reasonPopup.quickActions.highPrice'),
		tooltipDescription: t('reasonPopup.quickActions.tooHighPrice')
	},
	{
		quickActionIcon: GalleryIcon,
		tooltipIcon: GalleryIcon,
		tooltipTitle: t('reasonPopup.quickActions.badPhotos'),
		tooltipDescription: t('reasonPopup.quickActions.photosNotMatch')
	},
	{
		quickActionIcon: LocationIcon,
		tooltipIcon: LocationIcon,
		tooltipTitle: t('reasonPopup.quickActions.badLocation'),
		tooltipDescription: t('reasonPopup.quickActions.locationIsWrong')
	},
	{
		quickActionIcon: StarsIcon,
		tooltipIcon: StarsIcon,
		tooltipTitle: t('reasonPopup.quickActions.wrongStars'),
		tooltipDescription: t('reasonPopup.quickActions.starsSetWrong')
	}
]

export const getQuickLikeActions = (t: TFunction<'tooltips', undefined>) => [
	{
		quickActionIcon: PriceTagIcon,
		tooltipIcon: PriceTagIcon,
		tooltipTitle: t('reasonPopup.quickActions.goodPrice'),
		tooltipDescription: t('reasonPopup.quickActions.greatValueForPrice')
	},
	{
		quickActionIcon: GalleryIcon,
		tooltipIcon: GalleryIcon,
		tooltipTitle: t('reasonPopup.quickActions.greatPhotos'),
		tooltipDescription: t('reasonPopup.quickActions.appealingPhotos')
	},
	{
		quickActionIcon: LocationIcon,
		tooltipIcon: LocationIcon,
		tooltipTitle: t('reasonPopup.quickActions.excellentLocation'),
		tooltipDescription: t('reasonPopup.quickActions.idealLocationForNeeds')
	},
	{
		quickActionIcon: StarsIcon,
		tooltipIcon: StarsIcon,
		tooltipTitle: t('reasonPopup.quickActions.accurateRating'),
		tooltipDescription: t('reasonPopup.quickActions.correctlyReflectsQuality')
	}
]
